var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointGuest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a4c2b3d6-4f5d-4712-9f8d-9fd54e87f822",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f2ef7453-fe01-412c-8dff-ebd3b01da42b",
    d: "M98.38,24.28H29.63a13.51,13.51,0,0,0-13.5,13.5V96.53A13.51,13.51,0,0,0,29.63,110H98.38a13.52,13.52,0,0,0,13.5-13.5V37.78A13.51,13.51,0,0,0,98.38,24.28Zm10.5,72.25A10.51,10.51,0,0,1,98.38,107H29.63a10.51,10.51,0,0,1-10.5-10.5V68.65h8.5V79.5a11.75,11.75,0,0,0,23.5,0V68.65H87.08v19.6H77.33v3h20.5v-3H90.08V68.65h18.8ZM48.13,68.65V79.5a8.75,8.75,0,1,1-17.5,0V68.65Zm-17.5-3V53a8.75,8.75,0,1,1,17.5,0V65.65Zm78.25,0H90.08V44.53l-.87-2.88-12.4,4.57,1,2.81,9.23-3.39v20H51.13V53a11.75,11.75,0,1,0-23.5,0V65.65h-8.5V37.78a10.51,10.51,0,0,1,10.5-10.5H98.38a10.51,10.51,0,0,1,10.5,10.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f2ef7453-fe01-412c-8dff-ebd3b01da42b",
    cx: 62,
    cy: 56.44,
    r: 4.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f2ef7453-fe01-412c-8dff-ebd3b01da42b",
    cx: 62,
    cy: 77.44,
    r: 4.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointGuest);
export default __webpack_public_path__ + "static/media/point-guest.6b2ea085113ec00b3838cda77b6ba9ef.svg";
export { ForwardRef as ReactComponent };